import React, { useState, useContext, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import {
  TextField,
  InputAdornment,
  Box,
  IconButton,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Link,
} from "@mui/material";
import SnackBar from "CommonComponents/Snackbar/SnackBar.jsx";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import SendIcon from "@mui/icons-material/Send";
import LockResetIcon from "@mui/icons-material/LockReset";
import KeyIcon from "@mui/icons-material/Key";
import PersonIcon from "@mui/icons-material/Person";
import {
  postRecord,
  handleApiResponse,
  handleApiError,
} from "services/services";
import { AuthContext } from "context/Authentication";
import { onlyPassword, onlyEmail } from "commonmethods/Validatations";
import {
  getReturnUrlFromLocation,
  createRegisterUrlWithReturn,
} from "utils/authUtils";
const API_Login = "users/login";
const API_RequestResetLink = "users/request-reset-link";
export default function AuthLogin() {
  let navigate = useNavigate();
  const location = useLocation();

  const initialLoginState = {
    User_Email: "",
    User_Password: "",
  };
  // const { ErrorCode } = useParams();
  const { dispatch } = useContext(AuthContext);
  const [thisLogin, setThisLogin] = useState(initialLoginState);
  const [loading, setLoading] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [snackOptions, setSnackOptions] = useState({
    color: "success",
    message: "Hi",
  });
  const [resetDialogOpen, setResetDialogOpen] = useState(false);
  const [resetEmail, setResetEmail] = useState("");
  /** ------------------ useEffects ------------------------ */
  // useEffect(() => {
  //   ErrorCode && navigate("/CustomErrors/" + ErrorCode);
  // }, [ErrorCode]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setThisLogin({ ...thisLogin, [name]: value });
  };
  const handleLoginRedirect = (user) => {
    navigate(user.Default_Page);
  };
  const handleSubmitLogin = () => {
    // Prepare the login object
    const loginObj = {
      User_Email: thisLogin.User_Email,
      User_Password: thisLogin.User_Password,
    };

    setLoading(true); // Start the loading state

    // Make the API call using postRecord
    postRecord(API_Login, loginObj)
      .then((response) => {
        if (
          response.status === 200 &&
          response.data &&
          response.data?.Response_Data
        ) {
          var result = JSON.parse(response.data.Response_Data);
          setSnackOptions({
            color: result.Color || "success", // Use the color from the response or default to "success"
            message: result.Message || "Welcome back",
            icon: result.Icon || "CheckCircleIcon", // Use the icon from the response or default to success icon
          });
          setSnackOpen(true);
          setLoading(false);
          var userData = response.data;
          return userData;
        } else {
          if (
            response.status === 400 &&
            response.data &&
            response.data?.detail
          ) {
            var responseMessage = response.data.detail;
            setSnackOptions({
              color: "error",
              message: responseMessage || "Invalid login credentials.",
              icon: "ErrorOutlineOutlinedIcon",
            });
            setSnackOpen(true);
            setLoading(false);
            // Throw an error to prevent the next .then() from executing
            throw new Error("Login failed: " + responseMessage);
          }
          // If it's not a 200 or 400, also throw an error
          setLoading(false);
          throw new Error("Unexpected response: " + response?.data?.detail);
        }
      })
      .then((userData) => {
        // Only execute this block if userData exists (successful login)
        if (!userData) {
          return; // Skip execution if no userData
        }

        // console.log(userData);
        const Permissions = JSON.parse(userData.User_Permission);
        const Token = userData.Session_Token;
        const {
          User_Permission,
          Response_Data,
          Session_Token,
          ...filteredUserData
        } = userData;
        dispatch({
          type: "LOGIN",
          payload: {
            user: filteredUserData,
            permissions: Permissions,
            token: Token,
          },
        });

        // Check for Return_Url parameter, otherwise use default page
        const returnUrl = getReturnUrlFromLocation(location);
        // console.log("Return URL:", returnUrl);
        if (returnUrl && returnUrl != "/") {
          navigate(returnUrl);
        } else {
          navigate(userData.Default_Page);
        }
      })
      .catch((error) => {
        // Handle API or network errors
        if (error.response) {
          // Use error message from backend
          setSnackOptions({
            color: error.response.data?.Color || "error",
            message:
              error.response.data?.detail ||
              "Something went wrong during Login.",
            icon: error.response.data?.Icon || "ErrorOutlineOutlinedIcon",
          });
        } else {
          // Handle network or unexpected errors
          setSnackOptions({
            color: "error",
            message: error.message || "Network error. Please try again.",
            icon: "ErrorOutlineOutlinedIcon",
          });
        }

        setSnackOpen(true);
        setLoading(false); // Stop loading
      });
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const resetAndPreview = () => {
    setResetEmail("");
    setProcessing(false);
    // setThisLogin(initialLoginState);
    setResetDialogOpen(false);
  };
  const handleResetPassword = () => {
    setProcessing(true);
    postRecord(API_RequestResetLink, { User_Email: resetEmail })
      .then((response) => {
        setSnackOptions({
          color: "success",
          message: response.data.message,
        });
        setSnackOpen(true);

        resetAndPreview();
        // handleApiResponse(
        //   response,
        //   setSnackOptions,
        //   setProcessing,
        //   setSnackOpen,
        //   resetAndPreview
        // );
      })
      .catch((error) => {
        // console.log(error);
        handleApiError(error, setSnackOptions, setProcessing, setSnackOpen);
      });
  };

  return (
    <React.Fragment>
      <form
        onSubmit={(event) => {
          event.preventDefault();
          if (!onlyEmail(thisLogin.User_Email)) {
            setSnackOptions({
              color: "warning",
              message: "Please Enter Valid Email",
            });
            setSnackOpen(true);
          } else if (!onlyPassword(thisLogin.User_Password)) {
            setSnackOptions({
              color: "error",
              message:
                "Password must contain at least 8 characters, one uppercase and one lowercase character, one number and a special character",
            });
            setSnackOpen(true);
          } else {
            setLoading(true);
            setProcessing(true);
            handleSubmitLogin();
          }
        }}
      >
        <Box sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            type="email"
            label="Email"
            name="User_Email"
            onChange={handleInputChange}
            value={thisLogin.User_Email}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <PersonIcon color="primary" />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            label="Password"
            type={showPassword ? "text" : "password"}
            name="User_Password"
            onChange={handleInputChange}
            value={thisLogin.User_Password}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <KeyIcon color="primary" />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            disabled={loading}
            startIcon={
              loading ? <CircularProgress size={20} /> : <LockResetIcon />
            }
          >
            LogIn
          </Button>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Button
              type="reset"
              variant="text"
              color="warning"
              onClick={() => setResetDialogOpen(true)}
              sx={{ textTransform: "none" }}
            >
              Reset Password
            </Button>
            <Button
              type="reset"
              variant="text"
              color="info"
              sx={{ textTransform: "none" }}
              onClick={() => {
                const currentPath = location.pathname + location.search;
                const returnUrl =
                  getReturnUrlFromLocation(location) || currentPath;
                const registerUrl = createRegisterUrlWithReturn(returnUrl);
                navigate(registerUrl);
              }}
            >
              Create Account
            </Button>
          </Box>
        </Box>
      </form>
      <Dialog open={resetDialogOpen} onClose={() => setResetDialogOpen(false)}>
        <DialogTitle>Reset Password</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Enter your email address below and we will send you a link to reset
            your password.
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            label="Email Address"
            type="email"
            fullWidth
            variant="outlined"
            value={resetEmail}
            onChange={(e) => setResetEmail(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setResetDialogOpen(false)} color="primary">
            Cancel
          </Button>
          <Button
            onClick={handleResetPassword}
            color="primary"
            disabled={processing}
            startIcon={
              processing ? <CircularProgress size={20} /> : <SendIcon />
            }
          >
            Send
          </Button>
        </DialogActions>
      </Dialog>
      <SnackBar
        open={snackOpen}
        setOpen={setSnackOpen}
        options={snackOptions}
      />
    </React.Fragment>
  );
}
